import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { App, Form, Input, Button, Card } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { authService } from '../services/auth.service';
import './Login.css';

const Login: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { message } = App.useApp();

  const onFinish = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      await authService.login(values);
      message.success(t('auth.loginSuccess'));
      navigate('/');
    } catch (error: any) {
      if (!error.response && error.message?.includes('Network Error')) {
        message.error(t('auth.corsError'));
      } else {
        message.error(error.response?.data?.message || t('auth.loginError'));
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <Card className="login-card">
        <div className="login-header">
          <h1 className="login-title">{t('app.title')}</h1>
          <p className="login-subtitle">{t('app.subtitle')}</p>
        </div>
        
        <Form
          name="login"
          onFinish={onFinish}
          autoComplete="off"
          layout="vertical"
          initialValues={{
            email: '',
            password: ''
          }}
        >
          <Form.Item
            name="email"
            rules={[
              { required: true, message: t('auth.emailRequired') },
              { type: 'email', message: t('auth.emailInvalid') }
            ]}
          >
            <Input
              prefix={<MailOutlined />}
              placeholder={t('auth.enterEmail')}
              size="large"
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: t('auth.passwordRequired') }]}
          >
            <Input.Password
              prefix={<LockOutlined />}
              placeholder={t('auth.enterPassword')}
              size="large"
            />
          </Form.Item>

          <Form.Item>
            <div className="login-links">
              <Link to="/reset-password" className="forgot-password-link">
                {t('auth.forgotPassword')}
              </Link>
            </div>
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              size="large"
              block
            >
              {t('auth.login')}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default Login;
